module.exports = __webpack_public_path__ + "front/img/p14.466c3a9b.png";